// extracted by mini-css-extract-plugin
export default {"content":"step4_content__JVqmx","rejected":"step4_rejected__b0NNR","cards":"step4_cards__Cujkl","terms":"step4_terms__u+Edn"};